var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-line"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"dot",class:{ active: _vm.isActive && (_vm.childLabel === '牛肉' || _vm.childLabel === '活牛'),
  active1: _vm.isActive && _vm.childLabel === '现货',
  active2: _vm.isActive && _vm.childLabel === '期货',
  active3: _vm.isActive && _vm.childLabel === '日行情',
  active4: _vm.isActive && _vm.childLabel === '周行情' }}),_c('div',{staticClass:"line",class:{ hide: _vm.isLast }})])
}
var staticRenderFns = []

export { render, staticRenderFns }